import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { useTranslation } from 'react-i18next';
import actions from '../../redux/actions';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Notification = () => {
  const { t } = useTranslation();
  const notification = useSelector(state => state.notification);
  const dispatch = useDispatch();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch({
      type: actions.notification.SET_STATE,
      payload: {
        ...notification,
        open: false
      }
    });
  };

  return (
    <Snackbar
      autoHideDuration={3000}
      onClose={handleClose}
      open={notification.open}
    >
      <Alert onClose={handleClose} severity={notification.severity}>
        {t(notification.message)}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
